const OrderType = {
  Quote: 1,
  Order: 2
};

export default OrderType;
